'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultLinkComponent = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  href: _propTypes2.default.string,
  title: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};

var defaultProps = {
  href: '',
  title: 'defaultLink',
  onClick: _reactackleCore.noop
};

var DefaultLinkComponent = exports.DefaultLinkComponent = function DefaultLinkComponent(props) {
  var content = props.children || props.title;

  return _react2.default.createElement(
    'a',
    { href: props.href, onClick: props.onClick },
    content
  );
};

DefaultLinkComponent.propTypes = propTypes;
DefaultLinkComponent.defaultProps = defaultProps;
DefaultLinkComponent.displayName = 'DefaultLinkComponent';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-tabs/dist/Link/DefaultLinkComponent.js
// module id = 135
// module chunks = 0